import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Dashboard from './pages/Dashboard/Dashboard';
import Strategies from './pages/Strategies/Strategies';
import StrategyCreate from './pages/Strategies/StrategyCreate';
import Backtest from './pages/Backtest/Backtest';
import LiveTrading from './pages/LiveTrading/LiveTrading';
import Market from './pages/Market/Market';
import Brokers from './pages/Brokers/Brokers';
import Profile from './pages/Profile/Profile';
import Login from './pages/Login/Login';
import YandexCallback from './pages/Auth/YandexCallback';
import MacroPage from './pages/Macro/MacroPage';
import BotsDashboard from './pages/Bots/BotsDashboard';
import BotCreate from './pages/Bots/BotCreate';
import BotDetail from './pages/Bots/BotDetail';
import Credentials from './pages/Credentials/Credentials';
import PressureDashboard from './pages/Pressure/PressureDashboard';
import PressureAlerts from './pages/Pressure/PressureAlerts';
import PressureBacktest from './pages/Pressure/PressureBacktest';

function App() {
  const { i18n } = useTranslation();

  // Set document direction for RTL languages
  React.useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Auth routes - no navbar */}
          <Route path="/login" element={<Login />} />
          <Route path="/auth/yandex/callback" element={<YandexCallback />} />

          {/* Main app routes - with navbar */}
          <Route path="/*" element={
            <>
              <Navbar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/strategies" element={<Strategies />} />
                  <Route path="/strategies/create" element={<StrategyCreate />} />
                  <Route path="/backtest" element={<Backtest />} />
                  <Route path="/trading" element={<LiveTrading />} />
                  <Route path="/market" element={<Market />} />
                  <Route path="/brokers" element={<Brokers />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/macro" element={<MacroPage />} />
                  <Route path="/bots" element={<BotsDashboard />} />
                  <Route path="/bots/new" element={<BotCreate />} />
                  <Route path="/bots/:id" element={<BotDetail />} />
                  <Route path="/credentials" element={<Credentials />} />
                  <Route path="/pressure" element={<PressureDashboard />} />
                  <Route path="/pressure/alerts" element={<PressureAlerts />} />
                  <Route path="/pressure/backtest" element={<PressureBacktest />} />
                </Routes>
              </main>
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
